import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import useStyles from "./filtered-list-count.style";
import { OcErrorBoundary } from "oc/components";

interface OcFilteredListCountProps {
  listCount: number;
}

export const OcFilteredListCount: React.FC<OcFilteredListCountProps> = ({
  listCount,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <OcErrorBoundary>
      <Box
        height="56px"
        className={classes.container}
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          paddingRight="16px"
          fontSize="16px"
          letterSpacing="0.44px"
          color="#4d4d4d"
          textAlign="center"
        >
          {t("OC_COUNT_OF_EMPLOYEES")}
        </Box>
        <Box fontSize="34px" letterSpacing="0.25px" className={classes.counter}>
          {listCount}
        </Box>
      </Box>
    </OcErrorBoundary>
  );
};

export default OcFilteredListCount;
